import {
  NumberInput,
  NumberInputFeedback,
} from '@euler/components/NumberInput';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useState } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';
import { Pencil } from './PencilIcon';

export const ValueInputCell = memo(
  ({
    valueUnit,
    value,
    style,
    onChange,
  }: {
    valueUnit?: string;
    value?: number;
    style?: StyleProp<ViewStyle>;
    onChange?: (value: number | undefined) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const {
      inspection: {
        siteInspection: {
          valueInput: {
            bgColor,
            iconColor,
            placeholderTextColor,
            textColor,
            errorBgColor,
            errorTextColor,
          },
        },
      },
    } = useTheme();

    const [feedback, setFeedback] = useState<NumberInputFeedback>();

    return (
      <View
        css={`
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          height: ${rpx(39)}px;
          padding: 0 ${rpx(12)}px;
          border-radius: ${rpx(5)}px;
          background-color: ${feedback === 'show-invalid-state'
            ? errorBgColor
            : bgColor};
        `}
        style={style}
      >
        <Pencil
          color={feedback === 'show-invalid-state' ? errorTextColor : iconColor}
        />
        <View
          css={`
            width: 1px;
            height: ${rpx(20)}px;
            background-color: ${feedback === 'show-invalid-state'
              ? errorTextColor
              : iconColor};
            margin-left: ${rpx(8)}px;
          `}
        />
        <NumberInput
          keyboardType="numbers-and-punctuation"
          placeholder={`手动填写检测结果${valueUnit ? `(${valueUnit})` : ''}`}
          placeholderTextColor={placeholderTextColor}
          value={value}
          onChangeValue={onChange}
          onRequestFeedback={setFeedback}
          css={`
            height: 100%;
            flex: 1;
            padding: 0 ${rpx(9)}px;
            color: ${feedback === 'show-invalid-state'
              ? errorTextColor
              : textColor};
          `}
        />
      </View>
    );
  },
);
